import React, { Component } from "react";
import { Row, Col, Card, Table, Button } from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import { URL, localFilePath } from "../../redux/actions/constants";
import pdfIcon from "../../images/pdfIcon.png";

class PinPullTestDetail extends Component {
  state = {
    pageTitle: "Pin Çekme Testi Detay",
    pageTitleDetail: "Pin Çekme Testi Detay",
    pageAddLink: "pin-cekme-testi-ekle",
    pageListLink: "pin-cekme-testi-listele",
    breadcrumb: [{ text: "Pin Çekme Testi", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    productName: "",
    customerName: "",
    productOutName: "",
    currencyType: "",
    workInstructionCode: "",
    detectionPersonelName: "",
    serialNo: "",
    testSerialNo: "",
    dispatchPiece: "",
    status: "",
    createdBy: "",
    createdAt: "",
    updatedAt: "",
    updatedBy: "",
    productOutDate: "",
    productOutCustomer: "",
    productOutTotal: "",
    pinPullestDate: "",
    pinPullTestDeviceUsedDto: [],
    pinPullTestProductDto: [],
    personelName: "",
   };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/pinPullTests/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            guid: response.data.guid,
            workInstructionCode: response.data.workInstructionCode,
            customerName: response.data.customerName,
            productCode: response.data.productCode,
            productName: response.data.productName,
            detectionPersonelName: response.data.detectionPersonelName,
            personelName: response.data.personelName,
            productOutCustomer: response.data.productOutCustomer,
            productOutDate: response.data.productOutDate,
            productOutTotal: response.data.productOutTotal,
            pinPullTestDate: response.data.pinPullTestDate,
            pinPullTestDeviceUsedDto: response.data.pinPullTestDeviceUsedDto,
            pinPullTestProductDto: response.data.pinPullTestProductDto,
            currencyType: response.data.currencyType,
            serialNo: response.data.serialNo,
            testSerialNo: response.data.testSerialNo,
            dispatchPiece: response.data.dispatchPiece,
            status: response.data.status,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  handlePdfPrint = async (guid) => {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await axios
      .get(URL + "/pinPullTests/print/" + guid, config)
      .then((response) => {
        var myData = response.data;
        let replaceLink = myData.replace(localFilePath, "");
        if (replaceLink) {
          window.open(replaceLink, "_blank");
          this.setState({
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  };

  render() {
    const mainRow = {
      backgroundColor: "#1d4b8c",
      color: "#fff",
    };
    const subRow = {
      backgroundColor: "#f2f2f2",
    };
    var self = this.state;

    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
          printLink={onClick => this.handlePdfPrint(this.state.guid)}
        />
        <Row>
          <Col>
            <Card body className="table-responsive">
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}
              <Table className="table table-responsive table-hover">
                <tbody>
                  <tr>
                    <th>Tarih</th>
                    <td colSpan="4">
                      {this.state.pinPullTestDate}
                    </td>
                  </tr>             
                  <tr>
                    <th>İş Emri Numarası</th>
                    <td colSpan="4">{this.state.workInstructionCode}</td>
                  </tr>
                  {/* <tr>
                    <th>Kalite Personeli</th>
                    <td colSpan="4">{this.state.customerName}</td>
                  </tr>
                  <tr>
                    <th>Son Kontrolü Yapan Personel</th>
                    <td colSpan="4">{this.state.lastControlPersonelName}</td>
                  </tr> */}
                  <tr>
                    <th>Tespiti Yapan Personel</th>
                    <td colSpan="4">{this.state.detectionPersonelName}</td>
                  </tr>
                  <tr>
                    <th>Müşteri</th>
                    <td colSpan="4">{this.state.customerName}</td>
                  </tr>
                  <tr>
                    <th>Satış</th>
                    <td colSpan="4">{this.state.productOutDate + "-" + this.state.productOutCustomer}</td>
                  </tr>
                  <tr>
                    <th>Ürün</th>
                    <td colSpan="4">{this.state.productName}</td>
                  </tr>

                  <tr>
                    <th>Sevk Edilecek Ürün Miktarı</th>
                    <td colSpan="4">{this.state.dispatchPiece}</td>
                  </tr>

                  <tr>
                    <th>Seri Numarası</th>
                    <td colSpan="4">{this.state.serialNo === "" ? "-" : this.state.serialNo}</td>
                  </tr>
                
                  <tr>
                    <th>Test Seri Numarası</th>
                    <td colSpan="4">{this.state.testSerialNo === "" ? "-" : this.state.testSerialNo}</td>
                  </tr>

                  <tr>
                    <th>Kaydeden Kullanıcı</th>
                    <td>{this.state.createdBy ? this.state.createdBy : "-"}</td>
                    <th>Kaydedilme Tarihi</th>
                    <td>{this.state.createdAt ? this.state.createdAt : "-"}</td>
                  </tr>
                  <tr>
                    <th>Son Güncelleyen Kullanıcı</th>
                    <td>{this.state.updatedBy ? this.state.updatedBy : "-"}</td>
                    <th>Son Güncellenme Tarihi</th>
                    <td>{this.state.updatedAt ? this.state.updatedAt : "-"}</td>
                  </tr>
                </tbody>
              </Table>

              {this.state.pinPullTestDeviceUsedDto !== null &&
                this.state.pinPullTestDeviceUsedDto.length > 0 && (
                  <>
                  <div
                  className="row"
                  style={{
                    display:
                      self.pinPullTestDeviceUsedDto !== null && self.pinPullTestDeviceUsedDto.length > 0
                        ? ""
                        : "none",
                  }}
                >
                  <h2 className="mt-2">Kullanılan Cihaz Bilgileri</h2>
                </div>
                <Table className="table table-responsive table-hover table-product2">
                    <tr style={mainRow}>
                      <th>Kullanılan Cihaz</th>
                    </tr>
                    {this.state.pinPullTestDeviceUsedDto.map(function (item) {
                      return (
                        <tr style={subRow}>
                          <td>{item.deviceUsedName}</td>
                        </tr>
                      );
                    })}
                  </Table>
                  </>
                )}


              {this.state.pinPullTestProductDto !== null &&
                this.state.pinPullTestProductDto.length > 0 && (
                  <>
                  <div
                  className="row"
                  style={{
                    display:
                      self.pinPullTestProductDto !== null && self.pinPullTestProductDto.length > 0
                        ? ""
                        : "none",
                  }}
                >
                  <h2 className="mt-2">İtme Testi Bilgileri</h2>
                </div>
                <Table className="table table-responsive table-hover table-product2">
                    
                    {this.state.pinPullTestProductDto.map(function (item) {
                      return (
                        <>
                       <tr style={mainRow}>
                        <th style={{backgroundColor: "#9B9796", color: "#fff"}}>Ürün</th>
                        <th style={{backgroundColor: "#9B9796", color: "#fff"}}>El Aleti</th>
                        <th style={{backgroundColor: "#9B9796", color: "#fff"}}>Ürün</th>
                        <th style={{backgroundColor: "#9B9796", color: "#fff"}}>El Aleti</th>
                        <th style={{backgroundColor: "#9B9796", color: "#fff"}}>Ölçülen Değer</th>
                        <th style={{backgroundColor: "#9B9796", color: "#fff"}}>Olması Gereken Min. Değer</th>
                         <th style={{backgroundColor: "#9B9796", color: "#fff"}}>Sonuç</th>
                         </tr>
                          <tr style={subRow}>
                          <td>{item.productName}</td>
                          <td>{item.materialName}</td>
                          <td>{item.productName2}</td>
                          <td>{item.materialName2}</td>
                          <td>{item.measuredValue}</td>
                          <td>{item.minValue}</td>
                          <td className="font-weight-bold">{item.resultChange === 1 ? "Uygun" : "Uygun Değil"}</td>
                        </tr>
                        <tr>
                         <th style={{backgroundColor: "#9B9796", color: "#fff"}} colSpan={7}>Açıklama</th>
                      </tr>
                        <tr>
                          <td colSpan={7}>{item.description === "" ? "-" : item.description}</td>
                        </tr>
                        </>
                      );
                    })}
                  </Table>
                  </>
                )}

           </Card>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default PinPullTestDetail;
